import type {
  HistoricalBetState,
  HistoricalBetsPayload,
  RawHistoricalBetsPayload
} from '../../types/historicalBets';

const isBetsCountGreaterThanZero = (
  payload: RawHistoricalBetsPayload
): payload is HistoricalBetsPayload => payload.betsCount > 0;

const betsLoadedSuccessfully = (
  state: HistoricalBetState,
  payload: RawHistoricalBetsPayload
): HistoricalBetState => {
  if (isBetsCountGreaterThanZero(payload)) {
    return {
      ...state,
      isFetching: false,
      bets: [...state.bets, ...payload.content.Bets.bet],
      moreAvailable: state.bets.length + payload.content.Bets.bet.length < payload.betsCount
    };
  }

  return {
    ...state,
    isFetching: false,
    bets: []
  };
};

export default betsLoadedSuccessfully;
